// Add your custom JS here.


(function($){

    let lastScrollTop = 0;
    $(window).scroll(function() {

      let st = $(this).scrollTop();
      if (st > lastScrollTop){
        if($(document).scrollTop() >= 200)
        {
          $('.header').addClass('scroll-header');

        } else {
          $('.header').removeClass('scroll-header');
        }
      } else {
        $('.header').removeClass('scroll-header');
      }
      lastScrollTop = st;
      
    });


    $('.sp-contact-modal').on('click', function() {
        $('#contact-modal').addClass('show-modal');
        $('body').css('overflow', 'hidden');
    });

    $('.contact-modal__close').on('click', function() {
        $('#contact-modal').removeClass('show-modal');
        $('body').css('overflow', 'auto');
    });

    $(window).on('click', function(event) {
        if ($(event.target).is('#contact-modal')) {
            $('#contact-modal').removeClass('show-modal');
            $('body').css('overflow', 'auto');
        }
    });
})(jQuery);